import * as React from "react";

function PayCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "PayCircleOutline-PayCircleOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayCircleOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "PayCircleOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M24,5 C13.5065898,5 5,13.5065898 5,24 C5,34.4934102 13.5065898,43 24,43 C34.4934102,43 43,34.4934102 43,24 C43,13.5065898 34.4934102,5 24,5 Z M29.481684,12.6536905 L29.5554769,12.6868007 L31.4514212,13.7775476 C31.4517209,13.77772 31.4520203,13.7778928 31.4523195,13.778066 L31.5180198,13.8254803 C31.6372256,13.9314105 31.682089,14.0995545 31.6314989,14.2507889 L31.5981516,14.3246307 L26.5546134,23.0374511 L31.1,23.0381798 C31.3209139,23.0381798 31.5,23.2172659 31.5,23.4381798 L31.5,25.6305439 C31.5,25.8514578 31.3209139,26.0305439 31.1,26.0305439 L25.4996134,26.0304511 L25.4996134,28.0254511 L31.1,28.0254532 C31.3209139,28.0254532 31.5,28.2045393 31.5,28.4254532 L31.5,30.6178173 C31.5,30.8387312 31.3209139,31.0178173 31.1,31.0178173 L25.4996134,31.0174511 L25.5,35.6 C25.5,35.8209139 25.3209139,36 25.1,36 L22.9,36 C22.6790861,36 22.5,35.8209139 22.5,35.6 L22.4996134,31.0174511 L16.9,31.0178173 C16.6790861,31.0178173 16.5,30.8387312 16.5,30.6178173 L16.5,28.4254532 C16.5,28.2045393 16.6790861,28.0254532 16.9,28.0254532 L22.4996134,28.0254511 L22.4996134,26.0304511 L16.9,26.0305439 C16.6790861,26.0305439 16.5,25.8514578 16.5,25.6305439 L16.5,23.4381798 C16.5,23.2172659 16.6790861,23.0381798 16.9,23.0381798 L21.3286134,23.0374511 L16.2864814,14.3246307 C16.1758221,14.1334306 16.2411134,13.8887252 16.4323135,13.778066 L16.4327625,13.7778065 L18.329156,12.6868007 C18.5202914,12.5768395 18.764366,12.6423015 18.8748225,12.8331512 L23.9416134,21.5884511 L29.0098105,12.8331512 C29.1064599,12.6661577 29.3054107,12.5951642 29.481684,12.6536905 Z",
    id: "PayCircleOutline-\u5F62\u72B6\u7ED3\u5408",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default PayCircleOutline;